import { Subscription, SubscriptionLike } from 'rxjs';
import { TypeDecorator } from '@angular/core';

type SubscriptionMap = { [key: string]: SubscriptionLike; };

export function AutoSubOnDestroy(): TypeDecorator {
    return AutoSubClass.unsubscribeOnDestroy();
}

export function AutoSub(component): AutoSubClass {
    return AutoSubClass.instance(component);
}

export function ngOnDestroyHook(target) {
    const originalNgOnDestroy: Function = target.prototype.ngOnDestroy;
    // Create a new auto sub instance getter for this class
    target.prototype.getAutoSub = function() {
        if(!this.autoSub) {
            this.autoSub = new AutoSubClass();
            this.autoSub.id = ++AutoSubClass.idCnt;
        }
        return this.autoSub;
    }
    // List of subscriptions
    target.prototype.ngOnDestroy = function() {
        // Unsubscribe from all
        for(let subKey of Object.keys(this.getAutoSub().reg)) {
            // console.log("Auto unsubscribe ", subKey);
            this.getAutoSub().reg[subKey]?.unsubscribe();
        }

        // Execute component ng destroy
        if(originalNgOnDestroy) {
            originalNgOnDestroy.apply(this);
        }
    };
};

export class AutoSubClass {
    public static idCnt = 0;
    public id = 0;

    public static instance(component): AutoSubClass {
        return component.getAutoSub();
    }

    // List of subscriptions
    public reg: SubscriptionMap = new Proxy({}, {
        get: (target, prop, receiver) => {
            return target[prop];
        },
        set: (target: SubscriptionMap, prop: string, val: SubscriptionLike, receiver) => {
            // ! Unnecessary type check
            // The value needs to be either null or a Subscription type
            // if(!(val == null || val instanceof Subscription)) {
            //     console.error("AutoSub reg requires Subscription types, not this:", val);
            //     return false;
            // }

            // If a value with an unsubscribe method exists at `target[prop]`, invoke unsubscribe before setting a new value
            if(target[prop] && target[prop].unsubscribe) target[prop].unsubscribe();
            // Set the value
            target[prop] = val;
            return true;
        }
    });

    public unsubscribe(subKey?: string): void {
        // If key is not provided, unsubscribe from all
        if(subKey == undefined) return this.unsubscribeAll();
        // Unsubscribe from specific subscription
        if(this.reg[subKey]) this.reg[subKey].unsubscribe();
        this.reg[subKey] = null;
    }

    public unsubscribeAll(): void {
        for(let subKey of Object.keys(this.reg)) {
            this.reg[subKey].unsubscribe();
            this.reg[subKey] = null;
        }
    }
    static unsubscribeOnDestroy(): TypeDecorator {
        return ngOnDestroyHook;
    }
}
